import { gql } from "@apollo/client";

export const GET_APP_FEATURE_BY_NAME = gql`
  query GetAppFeatureByName($name: String!) {
    appFeatureByName(featureName: $name) {
      id,
      name,
      appFeatureStatus,
    }
  }
`

export const GET_WEC_AI_SCHEDULERS_APP_FEATURES = gql`
  query GetWecAiSchedulersAppFeatures {
    wecAiAppFeatures {
      edges {
        node {
          id,
          name,
          state,
          description,
          lastModifiedAt,
          lastModifiedBy,
        }
      }
    }
  }
`